import { t } from "i18next";
import { useEffect, useState } from "react";
import { TextInputField, TextInputFieldProps } from "../TextInputField/TextInputField";

export type NumberInputFieldProps = Omit<TextInputFieldProps, "value" | "onChange"> & {
  value: number | undefined;
  onChange: (number: number | undefined) => void;
};

/**
 * @deprecated Use NumberInput instead
 */
export const NumberInputField = ({ value, onChange, ...props }: NumberInputFieldProps) => {
  const [inputValue, setInputValue] = useState<string>(value !== undefined ? String(value) : "");

  const getNumberFromString = (str: string) => {
    // First check if it is an integer, then check if it is a float
    const intRegExp = new RegExp("^-?[0-9]+$");
    const floatRegExp = new RegExp("^-?[0-9]+[.][0-9]+$");

    if (intRegExp.test(str)) {
      return parseInt(str);
    } else if (floatRegExp.test(str)) {
      return parseFloat(str);
    } else {
      return undefined;
    }
  };

  // Reset inputVal if props.value changes
  useEffect(() => {
    if (value !== undefined) {
      setInputValue(String(value));
    } else {
      setInputValue("");
    }
  }, [value]);

  // Handle new text value and pass to parent if valid
  const handleTextChange = (text: string) => {
    const newText = text.trim().replaceAll(",", ".");
    const newNumber = getNumberFromString(newText);

    if (newNumber !== undefined || newText === "") {
      onChange(newNumber);
    }

    setInputValue(newText);
  };

  return (
    <TextInputField
      {...props}
      value={inputValue}
      onChange={handleTextChange}
      validate={(text) => (text && getNumberFromString(text) === undefined ? t("main.invalidValue") : false)}
    />
  );
};
